import React, { useState, useEffect } from 'react';

const MensajeCarga = () => {
  const [puntos, setPuntos] = useState('.');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setPuntos(prevPuntos => {
        if (prevPuntos === '...') return '.';
        return prevPuntos + '.';
      });
    }, 1000); // Cambia cada segundo

    return () => clearInterval(intervalId);
  }, []);

  return <p>Generando preguntas{puntos}</p>;
};

export default MensajeCarga;
